import React, {Component} from 'react';
import cx from 'classnames';

export default class Select extends Component {
  render() {
    const { options, label, name, disable, input, required, eng } = this.props;
    const labelStyles = cx('fc-input__label', {
      'fc-input__label--hidden': !label,
      'fc-input__label--disable': disable
    });
    // const inputStyles = cx('fc-input__input', {'fc-input__input--disable': disable});
    return (
      <div className="fc-input-wrapper">
        <select
          className="fc-input__input fc-select"
          name={name}
          onChange={input.onChange}
          required={required} >
          <option></option>
          {Object
            .keys(options)
            .map((key, i) => <option value={key} key={i}>{options[key]}</option>)}
        </select>
        <label htmlFor={name} className={labelStyles}>
          {label} <span className="label-eng">[{eng}]</span>
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/User/components/Select.js